export const FORM_DEBUG = import.meta.env.VITE_FORM_DEBUG === 'true';